import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

/**
 * Compact unsaved-changes prompt. It floats in the bottom-right corner only while there is
 * something to save, so it never sits on top of the form the rest of the time.
 */
@Component({
    selector: 'fb-save-bar',
    imports: [TranslatePipe, ButtonModule],
    template: `
        @if (visible()) {
            <div
                role="region"
                [attr.aria-label]="'UNSAVED_CHANGES' | translate"
                class="fixed bottom-5 right-5 z-50 flex items-center gap-3 pl-4 pr-2 py-2 rounded-md bg-surface border border-border shadow-lg animate-[fb-save-bar-in_160ms_ease-out]">
                <span class="size-3 rounded-full bg-brand shrink-0"></span>
                <span class="text-sm text-text whitespace-nowrap">{{ message() | translate }}</span>
                <span class="h-5 w-px bg-border"></span>
                <button pButton type="button" size="small" [text]="true" severity="secondary" [disabled]="saving()" (click)="discard.emit()">
                    {{ 'DISCARD' | translate }}
                </button>
                <button pButton type="button" size="small" [loading]="saving()" [disabled]="!canSave()" (click)="save.emit()">
                    {{ saveLabel() | translate }}
                </button>
            </div>
        }
    `,
    styles: `
        @keyframes fb-save-bar-in {
            from {
                opacity: 0;
                transform: translateY(8px);
            }
        }
    `
})
export class SaveBarComponent {
    visible = input(false);
    saving = input(false);
    canSave = input(true);
    message = input('UNSAVED_CHANGES');
    saveLabel = input('SAVE_CHANGES');

    save = output<void>();
    discard = output<void>();
}
